import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { Phone } from "@mui/icons-material";

export const MeetingTypes = {
  IN_PERSON: {
    key: '1',
    value: "In Person ",
  },
  PHONE_CALL: {
    key: '2',
    value: "Phone Call",
  },
  VIDEO_MEETING: {
    key: '3',
    value: "Video",
  },
  NO_LCOATION: {
    key: '4',
    value: "No location",
  },
};


export const MeetingOptions = [
  {
    key: MeetingTypes.IN_PERSON.key,
    label: MeetingTypes.IN_PERSON.value,
    icon: <LocationOnIcon />,
  },
  {
    key: MeetingTypes.PHONE_CALL.key,
    label: MeetingTypes.PHONE_CALL.value,
    icon: <Phone />,
  },
  {
    key: MeetingTypes.VIDEO_MEETING.key,
    label: MeetingTypes.VIDEO_MEETING.value,
    icon: <LiveTvIcon />,
  },

  {
    key: MeetingTypes.NO_LCOATION.key,
    label: MeetingTypes.NO_LCOATION.value,
    icon: null,
  },
];

export function getValueFromKey(key) {
  for (const type in MeetingTypes) {
    if (MeetingTypes[type].key === key) {
      return MeetingTypes[type].value;
    }
  }
  return null; // Return null if no matching key is found
}

export function getBookingType(bookingTypeCategoryId) {
  switch (bookingTypeCategoryId) {
    case 1:
      return "Event";
    case 2:
      return "Service";
    case 3:
      return "Class";
    default:
      return "Unknown"; // Handle other cases if needed
  }
}